<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="k-rtl">
          <div class="row">
            <div class="col-lg-3">
              <div
                  class="widget style1 cyan-bg"
              >
                <div class="row">
                  <div class="col-4 text-right">
                    <i class="fas fa-boxes fa-5x"></i>
                  </div>
                  <div class="col-8 text-left">
                    <span>تعداد محصولات </span>
                    <h2 class="font-bold">
                      <div v-if="isLoading">
                        <i class="fas fa-circle-notch fa-spin"></i>
                      </div>
                      {{ total.products_count ? total.products_count : 0 }}
                    </h2>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-3">
              <div class="widget style1 red-bg" @click="goto('/designer/orders')">
                <div class="row">
                  <div class="col-4 text-right">
                    <i class="fas fa-shopping-cart fa-5x"></i>
                  </div>
                  <div class="col-8 text-left">
                    <span>کل سفارشات </span>
                    <h2 class="font-bold">
                      <div v-if="isLoading">
                        <i class="fas fa-circle-notch fa-spin"></i>
                      </div>
                      {{ total.sales_count ? total.sales_count : 0 }}
                    </h2>
                  </div>
                </div>
                <div class="widget-box">
                  <a class="btn btn-outline-primary">اطلاعات بیشتر</a>
                </div>
              </div>
            </div>

            <div class="col-lg-3">
              <div class="widget style1 orange-bg"
                   @click="goto('/designer/deposits')">
                <div class="row">
                  <div class="col-4 text-right">
                    <i class="fas fa-wallet fa-5x"></i>
                  </div>
                  <div class="col-8 text-left">
                    <span>مجموع پرداختی</span>
                    <h2 class="font-bold">
                      <div v-if="isLoading">
                        <i class="fas fa-circle-notch fa-spin"></i>
                      </div>
                      {{ total.sum_pay ? $thousandSeprator(total.sum_pay) : 0 }}
                    </h2>
                  </div>
                </div>
                <div class="widget-box">
                  <a class="btn btn-outline-primary">اطلاعات بیشتر</a>
                </div>
              </div>
            </div>

            <div class="col-lg-3">
              <div class="widget style1 purple-bg">
                <div class="row">
                  <div class="col-4 text-right">
                    <i class="fas fa-coins fa-5x"></i>
                  </div>
                  <div class="col-8 text-left">
                    <div v-if="isLoading">
                        <i class="fas fa-circle-notch fa-spin"></i>
                      </div>
                    <div class="todeli">
                      <span>مجموع درآمد</span>
                      <h3>{{ total.sum_income ? $thousandSeprator(total.sum_income) : 0 }}</h3>
                    </div>
                    <div class="todeli">
                      <span>مانده طلب</span>
                      <h4>{{ remainPay ? $thousandSeprator(remainPay) : 0 }}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-2 mb-5">
            <div class="col-lg-6">
              <bita-ibox :is-loading="isLoading">
                <div slot="body">
                  <div class="k-rtl">
                    <bar-chart :data="charts.orders" title="تعداد سفارش" />
                  </div>
                </div>
              </bita-ibox>
            </div>
            <div class="col-lg-6">
              <bita-ibox :is-loading="isLoading">
                <div slot="body">
                  <div class="k-rtl">
                    <router-link
                        :to="{
                  path: '/designer/orders',
                }"
                    >
                      <h4>سفارشات اخیر</h4>
                    </router-link>
                    <table
                        v-if="total && total.orders && total.orders.data.length > 0"
                        class="table table-hover margin bottom"
                    >
                      <thead>
                      <tr>
                        <th style="width: 1%" class="text-center">ردیف</th>
                        <th>محصول</th>
                        <th class="text-center">زمان ثبت سفارش</th>
                        <th class="text-center">{{ $currencyLabel("درآمد") }}</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr
                          v-for="(item, index) of total.orders.data"
                          :key="index"
                      >
                        <td class="text-center">{{ index + 1 }}</td>
                        <td>{{ item.product_name }} <small>({{ item.product_price_name }})</small></td>
                        <td class="text-center small">
                          {{ $getJalaliDateTime(item.created_at) }}
                        </td>
                        <td class="text-center">
                      <span class="label label-primary">{{
                          $thousandSeprator(item.commission_amount)
                        }}</span>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                    <div class="text-center" v-else>سفارش جدیدی ثبت نشده است</div>
                  </div>
                </div>
              </bita-ibox>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BarChart from "@/components/template/BarChart.vue";
import {dashboardApi} from "@/api/apiManagement";
import Templates from "@/views/notifications/templates/Templates.vue";

export default {
  name: "DesignerHome",
  components: {Templates, BarChart},
  data() {
    return {
      total: {},
      charts: {},
      isLoading: false,
      isLoadingModal: false,
    };
  },
  mounted() {
    this.getDashboardData();
    if (this.$store.state.layout != "app-layout") this.$setLayout("app-layout");
  },
  computed: {
    remainPay() {
      return this.$thousandSeprator(this.total.sum_income - this.total.sum_pay);
    }
  },
  methods: {
    goto(input) {
      return this.$router.push(input);
    },
    getDashboardData() {
      this.isLoading = true;
      dashboardApi.getInfo().then(({data}) => {
        this.total = data.total;
        this.charts = data.charts;
        this.isLoading = false;
      });
    },
  }
}
</script>
<style>
  .todeli {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
</style>